// extracted by mini-css-extract-plugin
export default {"deleteColumn":"emails_deleteColumn__5fjni","tooltip":"emails_tooltip__rw1CP","active":"emails_active__QEiFz"};